import { useReferencedFn } from './useReferencedFn.js';
import { useState, useRef, useEffect } from 'react';

function useRunOnce(func, { condition = true, useEffectFn = useEffect } = {}) {
  const funcRef = useReferencedFn(func);
  const [hasRun, setHasRun] = useState(false);
  const strictModeHasRun = useRef(false);
  useEffectFn(() => {
    if (!condition || hasRun || strictModeHasRun.current) return;
    strictModeHasRun.current = true;
    void funcRef.current();
    setHasRun(true);
  }, [
    condition,
    hasRun,
    funcRef
  ]);
  return hasRun;
}

export { useRunOnce };
//# sourceMappingURL=useRunOnce.js.map
